import { ApolloCache, gql } from '@apollo/client';
import { CreateJournalEntryMutation, GetJournalEntriesQuery, GetJournalEntriesQueryVariables } from '../generated/graphql';
import { getJournalEntriesQuery } from '../queries/journalEntries';
import { forEachJournalEntriesQuery } from './cacheHelpers';

export const createJournalEntryMutation = gql`
    mutation CreateJournalEntry($data: JournalEntryCreateInput!) {
        createJournalEntry(data: $data) {
            id
            text
            rating
            ritualId
            ritualType
            taskName
            promptText
            createdAt
        }
    }
`;

export function createJournalEntryCache(cache: ApolloCache<any>, { data }: { data?: CreateJournalEntryMutation | null }) {
    if (!data?.createJournalEntry) return;

    const newEntry = data.createJournalEntry;
    forEachJournalEntriesQuery(cache, (vars, existingData) => {
        const entryExists = existingData.journalEntries.some(e => e.id === newEntry.id);
        if (!entryExists) {
            const newEntries = [newEntry, ...existingData.journalEntries];
            cache.writeQuery<GetJournalEntriesQuery, GetJournalEntriesQueryVariables>({
                query: getJournalEntriesQuery,
                variables: vars,
                data: { ...existingData, journalEntries: newEntries },
            });
        }
    });
}
